import {Deserializable} from "../deserializable.model";

export class ProjectPermissionModal implements Deserializable{
 
    public loggedInuserId: string = '';  
    public appType: string = '';    
    public clientId: string = '';
    public PROJECT_ID:string ='';
    public USER_NAME: string = '';
    public isExcludeProjectUser: boolean = true;
    
    deserialize(input: any) {
      Object.assign(this, input);
      return this;
    }

}


export class AppTypes implements Deserializable
{
  AppType_ID!: string;
  APPTYPE!:string;

    deserialize(input: any) {
        Object.assign(this, input);
        return this;
      }
}
